<div class="container">
  <app-header></app-header>
  <bolt-waiting-indicator id="loader"  fullScreen starthidden>Submitting your request...</bolt-waiting-indicator>
  <div class="content" [hidden]="isTimeout || showTimer">
    <router-outlet></router-outlet>
  </div>
  <div class="content" [hidden]="!isTimeout">
    <div class="page-body">
      <div class="timeout-heading pad-top-50px">Your session has expired</div>
      <div class="body-text" style="font-size:18px !important">We ended your session to help protect your information</div>
      <div class="body-text" style="font-size:18px !important">Please log in again to continue where you left off</div>
      <div class="pad-top-30px">
        <bolt-button type="primary" (click)="signInAgain()">Sign In Again</bolt-button>
      </div>
    </div>
  </div>
  <div class="content" [hidden]="!showTimer">
    <div class="page-body">
      <div class="bolt-row pad-top-50px">
        <div class="bolt-col-auto">
          <bolt-icon name="clock" class="icon-size"></bolt-icon>
        </div>
        <div class="bolt-col-auto">
          <div class="timeout-heading">Still there?</div>
          <div class="body-text" style="font-size:18px !important">Your session will expire in {{timeout}} seconds</div>
          <div class="pad-top-30px">
            <bolt-button type="primary" (click)="staySignedIn()">Stay Signed In</bolt-button>
          </div>
        </div>
        <div class="bolt-col-auto">
          <div class="timer-circle bolt-row">
            {{timeleft}}
          </div>
        </div>
      </div>

    </div>
  </div>
  <app-footer></app-footer>
</div>
